const APP_NAME = 'MixWire';

/**
 * Long enough to tell two parties apart, short enough that the name still
 * survives a browser tab — which is the only place this string is read.
 */
const MAX_PARTY_NAME_LENGTH = 22;

const truncate = (partyName: string): string =>
  partyName.length <= MAX_PARTY_NAME_LENGTH
    ? partyName
    : `${partyName.slice(0, MAX_PARTY_NAME_LENGTH - 1).trimEnd()}…`;

export const pageTitle = (partyName: string | undefined): string => {
  const trimmed = partyName?.trim() ?? '';
  return trimmed === '' ? APP_NAME : `${truncate(trimmed)} · ${APP_NAME}`;
};
